import React, {useContext, useEffect} from 'react';
import CommandsContext from '../../../../../../context/commandsContext';
import useKeyPress from '../../../../../../hooks/useKeyPress';
import BodyContentView from '../../../../../views/bodyContentView';

function PrinterTest({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onExit();
  }, [rightPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit, onRight: onExit});
    });
  }, [onExit]);

  return (
    <BodyContentView
      title="Printer Test"
      left="Options"
      right="Finished"
      caption="Printer test complete.  If printing did not occur, check wiring and verify that the configuration settings match the printer settings."
    />
  );
}

export default PrinterTest;
